import { CheckCircle, Circle, Truck, Package, MapPin } from 'lucide-react';

const statusIcons = {
    'Pedido Confirmado': Package,
    'En Preparacion': Package,
    'Enviado': Truck,
    'En Transito': Truck,
    'En Reparto': MapPin,
    'Entregado': CheckCircle,
};

export default function TrackingTimeline({ events = [] }) {
    return (
        <div className="relative" data-testid="tracking-timeline">
            {events.map((event, idx) => {
                const isLast = idx === events.length - 1;
                const Icon = statusIcons[event.status] || Circle;
                
                return (
                    <div key={idx} className="flex gap-4 pb-8 last:pb-0" data-testid={`tracking-event-${idx}`}>
                        {/* Timeline line + dot */}
                        <div className="flex flex-col items-center">
                            <div className={`w-8 h-8 rounded-sm flex items-center justify-center flex-shrink-0 ${
                                isLast ? 'bg-[var(--kraft-deep)] text-[var(--paper)]' : 'bg-[var(--line)] text-[var(--ink-soft)]'
                            }`}>
                                <Icon className="w-4 h-4" />
                            </div>
                            {idx < events.length - 1 && (
                                <div className="w-0.5 flex-1 bg-[var(--line)] mt-1" />
                            )}
                        </div>

                        {/* Content */}
                        <div className="pt-1 pb-2 min-w-0">
                            <p className={`font-heading text-sm font-bold uppercase tracking-wide ${
                                isLast ? 'text-[var(--kraft-deep)]' : 'text-[var(--ink)]'
                            }`}>
                                {event.status}
                            </p>
                            <p className="text-xs text-[var(--ink-soft)] mt-0.5">{event.description}</p>
                            <div className="flex items-center gap-3 mt-1.5">
                                {event.location && (
                                    <span className="text-[10px] text-[var(--ink-soft)] uppercase tracking-wider flex items-center gap-1">
                                        <MapPin className="w-3 h-3" /> {event.location}
                                    </span>
                                )}
                                <span className="font-mono text-[10px] text-[var(--ink-soft)]">
                                    {new Date(event.timestamp).toLocaleString('es-MX')}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
